import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  Button,
  Modal,
  Popover,
  Card,
  CardHeader,
  CardContent,
  CardMedia,
  FormControlLabel,
  Switch
} from "@mui/material";
import cardbackground from "../../assets/landing_page/new/Frame 2095584531.svg";
import EmptyPlan from "./EmptyPlan";
import CardPlan from "./CardPlan";
import PlanTable from "./PlanTable";
import http from "../../utils/http-common";
import { setTemplateForCreate } from "../../Slices/planslice";
import MyPlanTemplateChart from "../TemplateChart/MyPlanTemplateChart";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import { useDispatch } from "react-redux";
import addicon from "../../assets/landing_page/new/Vector (16).svg";
import upload from "../../assets/landing_page/Images/upload.png";
import templateImage from "../../assets/landing_page/Images/Template.png";
import {
  ViewList as ViewListIcon,
  Dashboard as DashboardIcon,
  Tune as TuneIcon,
  Brightness1 as CircleIcon,
} from "@mui/icons-material";
import Unlike from '../../assets/planshare icons/like.png';
import Saved from '../../assets/planshare icons/download.png';
import CloseIcon from "../../assets/landing_page/new/closeicon.svg";
import { toast } from "react-toastify";
function MyPlans() {
  const { drawerOpen, toggleDrawer } = useOutletContext();
  const [isClicked, setIsClicked] = useState(false);
  const [emptyUser, setEmptyUser] = useState(false);
  const [cardView, setCardView] = useState(true);
  const [gridView, setGridView] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState([]);
  const [jsonData, setJsonData] = useState([]);
  const [showSupportPlans, setShowSupportPlans] = useState(true);
  const [displayedPlans, setDisplayedPlans] = useState([]);
  const [planData, setPlanData] = useState([]);
  const handleClick = () => {
    dispatch(setTemplateForCreate({
      isTemplate: false,
      table: false,
      isTemplateToPlan: false,
      isBlankPlan: true
    }));

    setIsClicked(true);
    navigate("/home/createplan");
  };
  useEffect(() => {
    if (planData.length > 0) {
      setDisplayedPlans(planData);
    }
  }, [planData]);
  const handleClick1 = () => {
    dispatch(setTemplateForCreate({
      isTemplate: false,
      table: false,
      isTemplateToPlan: true
    }));

    setIsClicked(true);
    navigate("/home/createplan");
  };
  const handleClick2 = () => {
    dispatch(setTemplateForCreate({
      isTemplate: false,
      table: false,
      isTemplateToPlan: false,
      isBlankPlan: false
    }));

    setIsClicked(true);
    navigate("/home/createplan");
  };
  const handleCloseAddUser = () => {
    setIsClicked(false);
  };
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleOpen = (event) => {
    setOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };
  const [allTemplateData, setAllTemplateData] = useState([]);
  const FetchAllTemplates = async () => {
    try {
      const response = await http.get(
        "/master_service/template/list/data"
      );
      const myTemplates = response.data.My_Templates || [];
      const topPicks = response.data.Top_Picks || [];
      const featuredTemplates = response.data.Featured_Templates || [];

      // Combine all arrays
      const allTemplatesCombined = [...myTemplates, ...topPicks, ...featuredTemplates];

      // Deduplicate using a Map keyed by plan_id (you can change to "id" if needed)
      const uniqueTemplatesMap = new Map();

      allTemplatesCombined.forEach((template) => {
        if (!uniqueTemplatesMap.has(template.plan_id)) {
          uniqueTemplatesMap.set(template.plan_id, template);
        }
      });

      const uniqueTemplates = Array.from(uniqueTemplatesMap.values());

      setAllTemplateData(uniqueTemplates);
    } catch (e) {
      console.error("error", e);
    }
  };
  const handleView = async (id) => {
    try {
      const response = await http.get(`/master_service/template/view/data/${id}`);
      if (response.status === 200) {
        const data = response.data;
        setSelectedTemplate(data);
        // Fetch JSON data for chart
        const jsonResponse = await http.post(`/master_service/store-template-data`, {
          template_id: data.plan_id,
        });
        if (jsonResponse.status === 201) {
          setJsonData(jsonResponse.data.data.data.tasks);
        }
        else if (jsonResponse.status === 404) {
          setJsonData([]);
        }
        setViewModalOpen(true);
      }
    } catch (error) {
      setViewModalOpen(true);
      console.error("Error fetching template data:", error);
    }
  };

  const handleViewModalClose = () => {
    setViewModalOpen(false);
    setSelectedTemplate(null);
    setJsonData([]);
    window.location.reload();
  };
  // Add these handler functions
  const handleDownload = async () => {
    if (!selectedTemplate) return;
    const link = document.createElement("a");
    link.href = selectedTemplate.unload_file_Path;
    link.download = selectedTemplate.unload_file_Path.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    try {
      await http.post("/master_service/template/toppick/entry/data", {
        user_id: selectedTemplate.user_id,
        template_id: selectedTemplate.id,
        top_pick: "yes"
      });
      toast.success("Template downloaded successfully!");
    } catch (e) {
      console.error("error", e);
    }
  };

  const handleCopyAsPlan = async () => {
    if (!selectedTemplate) return;
    try {
      const response = await http.post("/master_service/template/copy/as/plan", {
        user_id: localStorage.getItem("user_id"),
        plan_name: selectedTemplate.plan_name,
        customer_name: selectedTemplate.customer_name,
        plan_description: selectedTemplate.plan_description,
        unload_file_Path: selectedTemplate.unload_file_Path
      });
      toast.success("Template saved as plan!");
    } catch (error) {
      console.error("Error while processing file:", error);
      toast.error("Failed to save.");
    }
  };
  const FilterModal = ({ open, handleClose }) => {
    return (
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='filter-modal-title'
        aria-describedby='filter-modal-description'>
        <Box
          sx={{
            position: "absolute",
            top: "30%",
            left: "80%",
            transform: "translate(-25%, -50%)",
            width: 90,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 1,
          }}>
          <Typography
            id='filter-modal-title'
            variant='h6'
            component='h2'
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "14.52px",
              textAlign: "left",
            }}>
            Recent Plan
          </Typography>
          <Typography
            id='filter-modal-title'
            variant='h6'
            component='h2'
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "14.52px",
              textAlign: "left",
              marginTop: "10px",
            }}>
            Old Plan
          </Typography>
          <Typography
            id='filter-modal-title'
            variant='h6'
            component='h2'
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "14.52px",
              textAlign: "left",
              marginTop: "10px",
            }}>
            Created by me
          </Typography>
          <Typography
            id='filter-modal-title'
            variant='h6'
            component='h2'
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "14.52px",
              textAlign: "left",
              marginTop: "10px",
            }}>
            Shared with me
          </Typography>
        </Box>
      </Modal>
    );
  };
  useEffect(() => {
    getPlan();
    FetchAllTemplates();
  }, []);
  const getPlan = async () => {
    try {
      const response = await http.get(
        "/master_service/get_all/plan_master/records"
      );

      if (response.status === 200) {
        if (response.data.length === 0) {
          setEmptyUser(true);
          setCardView(false);
        }

        const sortedData = response.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setPlanData(sortedData);
        handleClose();
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };
  const handleSortByRecentUser = async () => {
    try {
      const response = await http.get(
        "/master_service/get_all/plan_master/records"
      );

      if (response.status === 200) {
        if (response.data.length === 0) {
          setEmptyUser(true);
          setCardView(false);
        }

        const sortedData = response.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setPlanData(sortedData);
        handleClose();
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };
  const handleSortByExistingUser = async () => {
    try {
      const response = await http.get(
        "/master_service/get_all/plan_master/records"
      );

      if (response.status === 200) {
        if (response.data.length === 0) {
          setEmptyUser(true);
          setCardView(false);
        }

        const sortedData = response.data.sort(
          (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
        );
        setPlanData(sortedData);
        handleClose();
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }

  };
  const handleSortByCreated = async () => {
    try {
      const response = await http.get(
        "/master_service/get_all/plan_master/records"
      );

      if (response.status === 200) {
        if (response.data.length === 0) {
          setEmptyUser(true);
          setCardView(false);
        }
        const username = localStorage.getItem("user_name");
        const createdPlans = response.data.filter(
          (plan) => plan.created_by === username
        );
        setPlanData(createdPlans);
        handleClose();

      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const handleSortByShared = async () => {
    try {
      const response = await http.get(
        "/master_service/get_all/plan_master/records"
      );

      if (response.status === 200) {
        if (response.data.length === 0) {
          setEmptyUser(true);
          setCardView(false);
        }

        const username = localStorage.getItem("user_name");
        const sharedPlans = response.data.filter((plan) => plan.created_by !== username);
        setPlanData(sharedPlans);
        handleClose();

      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const sortCommentsBySeqNo = (comments) => {
    return comments.sort((a, b) => {
      const seqA = a.seq_no.split(".").map(Number);
      const seqB = b.seq_no.split(".").map(Number);

      for (let i = 0; i < Math.max(seqA.length, seqB.length); i++) {
        const partA = seqA[i] || 0; // Default to 0 if part is missing
        const partB = seqB[i] || 0; // Default to 0 if part is missing

        if (partA !== partB) {
          return partA - partB; // Sort based on difference
        }
      }

      return 0; // Equal seq_no
    });
  };
  const [templateData, setTemplateData] = useState([]);
  const [comments, setComments] = useState([]);
  const [templateId, setTemplateId] = useState(() => localStorage.getItem("templateId") || null);
  const fetchPlanData = async () => {
    try {
      const response = await http.get(`/master_service/template/view/data/${templateId}`);
      if (response.status === 200) {
        const data = response.data;
        setTemplateData(data);
        await fetchCommentsData(templateId);
        const tagsArray = templateData.tags ? templateData.tags.split(",") : [];
        fetchJsonData(data);
      }
    } catch (error) {
      console.error("Error fetching user data", error);
    }
  };

  const fetchJsonData = async (data) => {
    try {
      const response = await http.post(`/master_service/store-template-data`, {
        template_id: data.plan_id,
      });
      if (response.status === 201) {
        setJsonData(response.data.data.data.tasks);
      }
      else if (response.status === 404) {
        setJsonData([]);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const fetchCommentsData = async (templateId) => {

    const payload = {
      template_id: localStorage.getItem("templateId")
    }
    try {
      const response = await http.post(`/master_service/entity/list/details`, payload);
      if (response.status === 200) {
        // Extract and filter the nested data
        const filteredData = response.data.comments;
        sortCommentsBySeqNo(filteredData);
        setComments(filteredData);

      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };
  return (
    <div style={{ height: "100vh" }}>
      <>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",
            paddingLeft: '7px'
          }}>
          <Card
            variant='outlined'
            sx={{
              width: 160,
              height: '110px',
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              backgroundColor: "#f9f9f9",
              border: "1px dashed #ccc",
              margin: "3px"
            }}>
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}>
                <IconButton aria-label='settings'>
                  <img
                    src={addicon}
                    alt='More options'
                    style={{ width: "40px", height: "40px" }}
                    onClick={handleClick}
                  />
                </IconButton>
                <Typography
                  variant='body1'
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "12px", // Changed from 14px to 12px
                    fontWeight: 500, // Retained the 500 weight as specified
                    lineHeight: "14.52px", // Updated line-height to 14.52px
                    textAlign: "center", // Added text-align center
                  }}>
                  Create a Blank Plan?
                </Typography>
              </Box>
            </CardContent>
          </Card>
          <Card
            variant='outlined'
            sx={{
              width: 160,
              height: '110px',
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              backgroundColor: "#f9f9f9",
              border: "1px dashed #ccc",
              margin: "3px"
            }}>
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}>
                <IconButton aria-label='settings'>
                  <img
                    src={upload}
                    alt='upload'
                    style={{ width: "40px", height: "40px" }}
                    onClick={handleClick2}
                  />
                </IconButton>
                <Typography
                  variant='body1'
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "12px", // Changed from 14px to 12px
                    fontWeight: 500, // Retained the 500 weight as specified
                    lineHeight: "14.52px", // Updated line-height to 14.52px
                    textAlign: "center", // Added text-align center
                  }}>
                  Upload .Mpp file
                </Typography>
              </Box>
            </CardContent>
          </Card>
          <Card
            variant='outlined'
            sx={{
              width: 160,
              height: '110px',
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              backgroundColor: "#f9f9f9",
              border: "1px dashed #ccc",
              margin: "3px"
            }}>
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}>
                <IconButton aria-label='settings'>
                  <img
                    src={templateImage}
                    alt='templateImage'
                    style={{ width: "30px", height: "30px" }}
                    onClick={handleClick1}
                  />
                </IconButton>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  flexWrap: "nowrap",
                }}>
                <Typography
                  variant='body1'
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    marginBottom: '-4px',
                    fontSize: "12px", // Changed from 14px to 12px
                    fontWeight: 500, // Retained the 500 weight as specified
                    lineHeight: "14.52px", // Updated line-height to 14.52px
                    textAlign: "center", // Added text-align center
                  }}>
                  Create From Template
                </Typography>
              </Box>
            </CardContent>
          </Card>
          <Box
            sx={{
              overflowX: "auto",
              maxWidth: 4 * 180,          // 4 cards × (150 px width + 20 px margin)
              ml: 1,
              /* optional: hide scrollbar */
              "&::-webkit-scrollbar": { display: "none" },
            }}
          ><Box sx={{ display: "flex", flexWrap: "nowrap", gap: 2 }}>
              {allTemplateData.map((plan, index) => {
                return (
                  <Card
                    key={plan.id}
                    variant="outlined"
                    sx={{
                      flex: "0 0 160px",    // ← 0 grow, 0 shrink, 150 px basis
                      height: 110,
                      borderRadius: 2,
                      boxShadow: 1,
                      margin: '1px'
                    }}
                  >
                    <CardHeader sx={{ pb: 0, backgroundColor: "#E5EEFB66" }} />
                    <CardContent sx={{ px: 1, py: 0 }}>
                      <Box
                        sx={{
                          position: "relative",
                          width: "92%",
                          height: 80
                        }}
                      >
                        <CardMedia
                          component="img"
                          image={cardbackground}
                          alt="Project Timeline"
                          onClick={() => handleView(plan.id)}
                          sx={{
                            height: "50",
                            width: "100%",
                            borderRadius: 1,
                            objectFit: "cover",
                            backgroundColor: "#0000001A",
                            transition: "background-color 0.3s ease",
                            cursor: "pointer"
                          }}
                        />
                        <Typography
                          sx={{ fontSize: 12, fontWeight: 500, fontFamily: "Inter, sans-serif", textAlign: "center" }}
                        >
                          {plan.plan_name}
                        </Typography>

                      </Box>
                    </CardContent>
                  </Card>
                );
              })
              }
            </Box></Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "2px 0",
          }}>
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "20px",
              fontWeight: 600,
              lineHeight: "21px",
              textAlign: "left",
            }}>
            My Plans
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center" }}>
            <FormControlLabel
              control={
                <Switch
                  checked={showSupportPlans}
                  onChange={(e) => {
                    setShowSupportPlans(e.target.checked);
                    // Filter plans based on the toggle state
                    const filteredPlans = e.target.checked
                      ? planData
                      : planData.filter(plan => plan.users && plan.users.email !== "support@planshare.ai");
                    setDisplayedPlans(filteredPlans);
                  }}
                />
              }
              label="Show Sample Plans"
              sx={{ mr: 2 }}
            />
            <IconButton
              aria-label='grid view'
              sx={{ color: "black" }}
              onClick={() => {
                setCardView(true);
                setEmptyUser(false);
                setGridView(false);
              }}>
              <DashboardIcon fontSize='small' />
            </IconButton>
            <IconButton aria-label='list view' sx={{ color: "black" }}>
              <ViewListIcon
                fontSize='small'
                onClick={() => {
                  setGridView(true);
                  setEmptyUser(false);
                  setCardView(false);
                }}
              />
            </IconButton>
            <IconButton
              aria-label='filter'
              sx={{ color: "black" }}
              onClick={handleOpen}>
              <TuneIcon fontSize='small' />
            </IconButton>
          </Box>
        </Box>
        {emptyUser && (
          <div style={{ marginTop: "10px", height: "75%" }}>
            <EmptyPlan />
          </div>
        )}
        {cardView && (
          <div style={{ marginTop: "10px", height: "75%" }}>
            <CardPlan planData={displayedPlans} getPlan={getPlan} toggleDrawer={toggleDrawer} />
          </div>
        )}
        {gridView && (
          <div style={{ marginTop: "10px", height: "75%" }}>
            <PlanTable planData={planData} getPlan={getPlan} />
          </div>
        )}
      </>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}>
        <Box
          sx={{
            width: 90,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 1,
          }}>
          <Typography
            id='filter-popover-title'
            variant='h6'
            component='h2'
            onClick={handleSortByRecentUser}
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "14.52px",
              textAlign: "left",
              cursor: "pointer"
            }}>
            Recent Plan
          </Typography>
          <Typography
            id='filter-popover-title'
            variant='h6'
            component='h2'
            onClick={handleSortByExistingUser}
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "14.52px",
              textAlign: "left",
              marginTop: "10px",
              cursor: "pointer"
            }}>
            Existing Plan
          </Typography>
          <Typography
            id='filter-popover-title'
            variant='h6'
            component='h2'
            onClick={handleSortByCreated}
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "14.52px",
              textAlign: "left",
              marginTop: "10px",
              cursor: "pointer"
            }}>
            Created by me
          </Typography>
          <Typography
            id='filter-popover-title'
            variant='h6'
            component='h2'
            onClick={handleSortByShared}
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "14.52px",
              textAlign: "left",
              marginTop: "10px",
              cursor: "pointer"
            }}>
            Shared with me
          </Typography>
        </Box>
      </Popover>
      <Modal
        open={viewModalOpen}
        onClose={handleViewModalClose}
        aria-labelledby="template-view-modal"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '65%',
          maxHeight: '90vh',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          overflow: 'auto',
          borderRadius: 2
        }}>
          {selectedTemplate && (
            <div style={{ height: '100%', overflowY: 'auto' }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography variant="h6" component="h2">
                  {selectedTemplate.plan_name}
                </Typography>
                <IconButton onClick={handleViewModalClose}>
                  <img
                    src={CloseIcon}
                    alt='closeIcon'
                    style={{ width: "25px", height: "25px" }}
                  />
                </IconButton>
              </div>

              <div style={{ display: "flex", gap: "7px", marginTop: "16px" }}>
                {/* Left Side Content */}
                <div style={{ width: "50%" }}>
                  <Typography sx={{ color: "gray", mb: 2 }}>
                    By {selectedTemplate.created_by}
                    <CircleIcon sx={{ height: 8, width: 8, mx: 1 }} />
                    {selectedTemplate?.feature_template_details?.dataValues?.likes ?? 0}
                    <img src={Unlike} height="15" width="15" alt="like" style={{ marginLeft: "5px" }} />
                    <CircleIcon sx={{ height: 8, width: 8, mx: 1 }} />
                    {selectedTemplate.top_pick_count ?? 0}
                    <img src={Saved} height="15" width="15" alt="saved" style={{ marginLeft: "5px" }} />
                  </Typography>
                  <Typography sx={{ mb: 1 }}>Description</Typography>
                  <Typography variant="body1" sx={{ color: "gray", mb: 3 }}>
                    {selectedTemplate.plan_description}
                  </Typography>

                  <Typography sx={{ mb: 1 }}>Category</Typography>
                  {selectedTemplate.category && (
                    <Button
                      variant="outlined"
                      startIcon={[]} //icon[selectedTemplate.category]
                      sx={{
                        textTransform: "none",
                        borderRadius: "20px",
                        color: "gray",
                        borderColor: "#D3D3D3",
                        mb: 3
                      }}
                    >
                      {selectedTemplate.category}
                    </Button>
                  )}

                  <Typography sx={{ mb: 1 }}>Tags</Typography>
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                    {selectedTemplate.tags?.split(",").map((tag, index) => (
                      <Button
                        key={index}
                        variant="outlined"
                        sx={{
                          textTransform: "none",
                          borderRadius: "20px",
                          color: "gray",
                          borderColor: "#D3D3D3"
                        }}
                      >
                        {tag.trim()}
                      </Button>
                    ))}
                  </Box>
                  <Box sx={{ display: "flex", marginTop: 2, alignItems: "center" }}>
                    <Button
                      onClick={handleCopyAsPlan}
                      sx={{
                        fontFamily: "Inter, sans-serif",
                        textTransform: "none",
                        fontWeight: 500,
                        color: '#FFF',
                        width: '300px',
                        backgroundColor: "#FF2800",
                        padding: "4px 12px",
                        "&:hover": {
                          backgroundColor: "#FF2800",
                        },
                      }}
                    >
                      Create Plan
                    </Button>
                  </Box>
                </div>

                {/* Right Side - Chart */}
                <div style={{ maxwidth: "50%" }}>
                  <MyPlanTemplateChart projectData={jsonData} />
                </div>
              </div>
            </div>
          )}
        </Box>
      </Modal>
    </div>
  );
}
export default MyPlans;
